<template>
  <div>
    <v-menu
      v-model="datePickerMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      nudge-width="200"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="formattedDate"
          :label="$t('incidentReports.fields.birthday')"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="value.birthday"
        locale="de"
        @input="closeDatePicker"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      datePickerMenu: false,
    };
  },
  computed: {
    formattedDate() {
      return this.value.birthday
        ? new Date(this.value.birthday).toLocaleDateString("de-DE")
        : "";
    },
  },
  methods: {
    closeDatePicker() {
      this.datePickerMenu = false;
    },
  },
};
</script>
